module.exports = __webpack_public_path__ + "static/media/Bolitas de pollo búfalo.ecda4787.png";